import { render, staticRenderFns } from "./IconGoogleDrive.vue?vue&type=template&id=faced50a&"
import script from "./IconGoogleDrive.vue?vue&type=script&lang=js&"
export * from "./IconGoogleDrive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faced50a')) {
      api.createRecord('faced50a', component.options)
    } else {
      api.reload('faced50a', component.options)
    }
    module.hot.accept("./IconGoogleDrive.vue?vue&type=template&id=faced50a&", function () {
      api.rerender('faced50a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconGoogleDrive.vue"
export default component.exports